// extracted by mini-css-extract-plugin
module.exports = {"backButton":"BackButton__backButton--2miAT","backIcon":"BackButton__backIcon--9gmYO"};